import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { API_ENDPOINTS } from '../config/api';

// What a customer sees for each print stage (2026-09-28: artwork check added before printing).
const PRINT_STATUS_LABEL = {
  received: 'Received',
  artwork_check: 'Artwork being checked',
  printing: 'Printing',
  ready: 'Ready',
  completed: 'Completed',
};

export default function OrdersListPage() {
  const { getAuthHeaders } = useCustomerAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(API_ENDPOINTS.customerProfile.orders, { headers: getAuthHeaders() })
      .then((res) => {
        if (!res.ok) throw new Error('Could not load your orders');
        return res.json();
      })
      .then((data) => setOrders(data.orders || []))
      .catch((err) => setError(err.message || 'Could not load your orders'))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <main className="section">
        <div className="container" style={{ maxWidth: 720 }}>
          <div className="masthead" style={{ marginBottom: '24px' }}>
            <span className="eyebrow">Account</span>
            <h1>Your orders</h1>
          </div>

          {error && <div style={{ color: '#ef4444', marginBottom: '16px' }}>{error}</div>}
          {loading && <div className="loading" style={{ minHeight: '200px' }}><div className="loading-spinner" /></div>}

          {!loading && orders.length === 0 && (
            <div style={{ textAlign: 'center', color: 'var(--text-light)', padding: '40px 0' }}>
              <p style={{ marginBottom: '16px' }}>No orders yet.</p>
              <Link to="/design" className="btn btn-primary">Start an order</Link>
            </div>
          )}

          {orders.map((order) => (
            <Link key={order.id} to={`/account/orders/${order.id}`} className="list-row-card">
              <div>
                <div style={{ fontWeight: 700, color: 'var(--secondary-color)' }}>{order.orderNumber}</div>
                <div style={{ fontSize: '13px', color: 'var(--text-light)', marginTop: '2px' }}>
                  {new Date(order.createdAt).toLocaleDateString()} · {order.items?.length || 0} item(s) · ${order.total?.toFixed?.(2) ?? order.total}
                </div>
              </div>
              <span className="status-pill">{PRINT_STATUS_LABEL[order.printStatus] || order.printStatus || order.fulfillmentStatus}</span>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </>
  );
}
